import { useLocale } from '@gov-nx/core/service';
import { type PageCode } from '@gov-nx/module/page';
import { CopyButton, Tile, Tiles } from '@gov-nx/ui/web';
import { nameFormatting } from '@gov-nx/utils/common';
import { pageRouteResolver } from '@gov-nx/web';
import { ProfileROSTileDate } from './ProfileROSTileDate';
import type { ExtraConfig } from '@gov-nx/core/app';
import type { RequiredProperty } from '@gov-nx/core/types';
import type { OsobyPodnikatelRozsireneDto } from '@gov-nx/api';

type PFOListViewProps = {
	code: PageCode;
	PFOData: RequiredProperty<OsobyPodnikatelRozsireneDto, 'ico'>[];
} & ExtraConfig['profileRoutes']['rosConfig']['profileRosView']['PFOListView'];

export const PFOListView = ({
	code,
	PFOData,
	isDateOfCreationVisible,
	isDateOfTerminationVisible,
}: PFOListViewProps) => {
	const { t } = useLocale(code);

	if (!PFOData.length) return null;

	return (
		<section>
			<h2 className="text-headline-s! text-(--text-secondary)">
				{t('nadpis.podnikajici-fyzicka-osoba')}
			</h2>
			<Tiles>
				{PFOData.map((subject) => {
					const subjectName =
						subject.jmeno && subject.prijmeni
							? nameFormatting(subject.jmeno, subject.prijmeni)
							: '';
					return (
						<Tile
							key={subject.ico}
							name={subjectName}
							headlineLink={true}
							icon={{ name: 'chevron-right', type: 'components' }}
							to={pageRouteResolver('profil.ros.detail', {
								ico: subject.ico,
								agendaCode: subject.agenda?.kod,
							})}>
							<div className="flex flex-col justify-start gap-(--spacing-m) [ sm:flex-row sm:items-center ]">
								{subject.ico ? (
									<div className="flex items-center gap-1">
										<span className="inline-block mr-1! text-(--text-tertiary)">
											{t('zaznam.ico')}
										</span>
										<strong>{subject.ico}</strong>
										<CopyButton
											label={
												t('akce.kopirovat-cislo-dokladu') + ' ' + subject.ico
											}
											value={subject.ico}
										/>
									</div>
								) : null}

								{isDateOfCreationVisible ? (
									<ProfileROSTileDate
										label={t('zaznam.platnost-od')}
										date={subject.datumVzniku}
									/>
								) : null}
								{isDateOfTerminationVisible ? (
									<ProfileROSTileDate
										label={t('zaznam.platnost-do')}
										date={subject.datumZaniku}
									/>
								) : null}
							</div>
						</Tile>
					);
				})}
			</Tiles>
		</section>
	);
};
